/**
 * Der Anbieter eines Lieds — Wahl auf der Karte, Anzeige im Ergebnis. (11.10.2026, Ticket 3071)
 *
 * Martin, 07.10. 22:35, bei „Risen from the Ashes“: Beim Probestück war nicht erkennbar, welcher Anbieter gesungen hat; das Ergebnis
 * meldete es nicht, er musste nachfragen und wollte ElevenLabs. Jetzt steht der Anbieter auf der Vorschlagskarte (zur Wahl, wo der
 * Tarif zwei Dienste erlaubt) und auf der Karte des Ergebnisses (wer WIRKLICH komponiert hat, auch bei einem Ersatz).
 *
 * Angebunden sind Lyria (Standard) und ElevenLabs (Studio-Qualität, ab dem Paket Weg). Suno ist es nicht (Ticket 3003): es gibt
 * keinen offiziellen Zugang, und die Wahl von Anbieter, Schlüssel und Rechtsrisiko liegt bei Martin — darum steht Suno nirgends zur Wahl.
 *
 * EIN Besitzer für die Marke, die der Knopf der Karte an seine Nachricht hängt und die der SERVER liest (tools/generate_music.ts):
 *   „… vorschlag_id <12 hex> · anbieter elevenlabs“
 * Gelesen wird sie NUR hinter der Kennung — ein Titel kann sie nicht einschmuggeln, denn „vorschlag_id“ gehört allein dem Knopf.
 */
import { istFortschrittAnbieter, type FortschrittAnbieter } from "./lied-fortschritt.js";

export type LiedAnbieter = FortschrittAnbieter;

/** Die Marke hinter der Kennung; leer, wenn die Karte keine Wahl anbietet. */
export function anbieterMarke(a: LiedAnbieter | null): string {
  return a ? ` · anbieter ${a}` : "";
}

const HINTER_KENNUNG = /vorschlag_id [0-9a-f]{12} · anbieter ([a-z]+)(?![\p{L}\p{N}_])/u;

/** Der Anbieter, den der Knopf mitschickt — oder null (keine Marke, unbekannter Dienst). Rein. */
export function anbieterAusNachricht(nachricht: string): LiedAnbieter | null {
  const treffer = HINTER_KENNUNG.exec(nachricht);
  return treffer && istFortschrittAnbieter(treffer[1]) ? treffer[1] : null;
}

/** Die Dienste, die die Karte zur Wahl zeigt: aus dem Ergebnis des Servers, nur bekannte, mindestens zwei (sonst gibt es nichts zu wählen). */
export function anbieterWahlAus(roh: unknown): LiedAnbieter[] {
  if (!Array.isArray(roh)) return [];
  const alle = roh.filter(istFortschrittAnbieter);
  const einmal = [...new Set(alle)];
  return einmal.length >= 2 ? einmal : [];
}
